// ======= add dependencies =======
const KARIBA_DEPENDENCIES = [
  {
    url: 'https://storage.googleapis.com/kariba-public/juno/winwheel/Winwheel.min.js',
    type: 'script',
  },
  {
    url: 'https://cdnjs.cloudflare.com/ajax/libs/gsap/latest/TweenMax.min.js',
    type: 'script',
  },
  {
    url: 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit',
    type: 'script',
  },
  {
    url: 'https://cdn.jsdelivr.net/npm/fireworks-js@latest/dist/fireworks.js',
    type: 'script',
  },
  {
    url: 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.4.0/dist/confetti.browser.min.js',
    type: 'script',
  },
  {
    url: 'https://storage.cloud.google.com/dreamf-mcm-public-storage/assets/css/kariba.css',
    type: 'style',
  },
]
const addDependencies = function () {
  KARIBA_DEPENDENCIES.forEach((dependency) => {
    let importer
    if (dependency.type === 'script') {
      importer = document.createElement('script')
      importer.type = 'text/javascript'
      importer.src = dependency.url
      importer.id = dependency.id || new Date().getTime()
    } else if (dependency.type === 'style') {
      importer = document.createElement('link')
      importer.rel = 'stylesheet'
      importer.type = 'text/css'
      importer.href = dependency.url
    } else return
    document.head.appendChild(importer)
  })
}

export default addDependencies
